// src/pages/Users/Techniques/utils/speechUtils.js

export function hasJapaneseCharacters(value = "") {
  return /[\u3040-\u30FF\u4E00-\u9FFF]/.test(value);
}

export function pickJapaneseVoice() {
  if (typeof window === "undefined" || !window.speechSynthesis) {
    return {
      voice: null,
      lang: "ja-JP",
    };
  }

  const voices = window.speechSynthesis.getVoices?.() || [];

  const voice =
    voices.find((item) => item.lang?.toLowerCase().startsWith("ja")) || null;

  return {
    voice,
    lang: voice?.lang || "ja-JP",
  };
}

export function speakJapanese(text) {
  try {
    if (typeof window === "undefined") return;
    if (!window.speechSynthesis || !text) return;

    window.speechSynthesis.cancel();

    const { voice, lang } = pickJapaneseVoice();

    const utterance = new SpeechSynthesisUtterance(text);

    if (voice) utterance.voice = voice;

    utterance.lang = lang;
    utterance.rate = 0.92;
    utterance.pitch = 1;

    window.speechSynthesis.speak(utterance);
  } catch {
    // Pas bloquant.
  }
}